class CTAAnimation {
  constructor() {
    this.images = document.querySelectorAll(".img-animate img");
    this.init();
  }

  init() {
    this.images.forEach((img, index) => {
      // Set initial state
      gsap.set(img, {
        filter: index % 2 === 0 ? "blur(52px)" : "blur(0px)",
        scale: 1,
        opacity: 0.3,
      });

      // Create timeline for each image
      const tl = gsap.timeline({
        repeat: -1,
        yoyo: true,
        defaults: { duration: 3, ease: "power1.inOut" },
      });

      // Randomize animation delay
      const delay = Math.random() * 3;

      // Alternate between images
      if (index % 2 === 0) {
        tl.to(img, {
          y: -30,
          x: 30,
          filter: "blur(0px)",
          opacity: 0.5,
          delay,
        });
      } else {
        tl.to(img, {
          y: 15,
          x: -15,
          filter: "blur(52px)",
          opacity: 0.3,
          delay,
        });
      }
    });
  }
}

// Initialize animation when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new CTAAnimation();
});
